import { ChatMessageType } from "@/api/chat";
import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";

export type AgentAttachment = {
  id?: string;
  filename: string;
  mime_type: string;
  data: string;
  size: number;
};

export type OutgoingAgentMessage = {
  message: string;
  attachments?: AgentAttachment[];
  context?: AgentViewDescription;
  silent?: boolean;
  handoffMessage?: string;
};

export type AgentViewDescription = {
  context?: string;
  agent?: string;
  missing_vars?: string[];
  known_vars?: Record<string, unknown>;
} | null;

type AgentContextType = {
  canSendMessages: boolean;
  sendMessage: (payload: OutgoingAgentMessage) => void;
  messages: ChatMessageType[];
  submitEvent: (event: string | object) => void;
  usersTyping: { first_name: string; last_name: string; id: string }[];
  setCurrentViewDescription: Dispatch<SetStateAction<AgentViewDescription>>;
};

export const useAgentContext = () => useContext(AgentContext);
export const AgentContext = createContext<AgentContextType>({
  canSendMessages: false,
  sendMessage: (payload: OutgoingAgentMessage) => {
    console.warn("sendMessage not implemented", payload);
  },
  messages: [],
  submitEvent: (event: string | object) => {
    console.warn("submitEvent not implemented", event);
  },
  usersTyping: [],
  setCurrentViewDescription: () => {
    console.warn("setCurrentViewDescription not implemented");
  },
});
